import React, { useContext } from 'react'
import { Col, Row, Spin, Typography } from 'antd'

import IntlMessages from '../../../../util/IntlMessages'
import { SeoTags } from '../../../../components/seo-tags'
import LeaveTrackingInfo from '../../components/leave-tracking-info'
import { ThemeContext } from '../../../../context/themeContext'
import VTLogoPurple from '../../../../assets/images/logo-purple.svg'
import VTLogoWhite from '../../../../assets/images/logo.svg'
import { DARK_THEME } from '@vacationtracker/shared/constants/ThemeSetting'
import { SubscriptionPlanEnum } from '@vacationtracker/shared/types/company'

const { Paragraph, Title } = Typography

export interface ISignupLayoutProps {
  isBusy: boolean
  /**
   * Sits under the subtitle rather than inside the form, so an outcome keeps one place on the
   * page instead of pushing the field it belongs to further down.
   */
  banner?: React.ReactNode
  children: React.ReactNode
}

/**
 * The page frame. Class names are the ones the global stylesheet already defines, which is what
 * keeps this identical to the existing page.
 */
const SignupLayout = ({ isBusy, banner, children }: ISignupLayoutProps): React.ReactElement => {
  const { theme } = useContext(ThemeContext)

  return (
    <div className="auth-wrap new-signup">
      <SeoTags title="connect.meta.title.signup" description="connect.meta.description" />
      <div className="auth-container" id="connectPlatform">
        <Row>
          <Col span={12} className="auth-sidebar-info">
            <LeaveTrackingInfo selectedPlan={SubscriptionPlanEnum.complete} />
          </Col>
          <Col span={12} className="auth-sidebar-form">
            {/*
              One column, one width. Everything on this side is a full-width child of this panel,
              so the heading and the form cannot drift apart: the alternative is five elements
              each having to win its own width fight with the themed overrides.
            */}
            <div className="signup-panel">
              {/* The promo column carries the logo, and it is gone once the layout stops being
                  two columns, so the form column shows its own below that width. */}
              {theme === DARK_THEME ? <VTLogoWhite className="signup-mobile-logo" /> : <VTLogoPurple className="signup-mobile-logo" />}
              <Title level={3}>
                <IntlMessages id="signup.createYourAccount" />
              </Title>
              <Paragraph className="auth-sidebar-info-text">
                <IntlMessages id="signup.connectOrUseEmail" />
              </Paragraph>
              {banner}
              <Spin spinning={isBusy}>
                <div className="auth-sidebar-content">{children}</div>
              </Spin>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  )
}

export default SignupLayout
